import React from 'react'

const IcDatabase = ({ className, size = 20 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5 4.16666C17.5 5.54737 14.1421 6.66666 10 6.66666C5.85786 6.66666 2.5 5.54737 2.5 4.16666M17.5 4.16666C17.5 2.78594 14.1421 1.66666 10 1.66666C5.85786 1.66666 2.5 2.78594 2.5 4.16666M17.5 4.16666V15.8333C17.5 17.2167 14.1667 18.3333 10 18.3333C5.83333 18.3333 2.5 17.2167 2.5 15.8333V4.16666M17.5 9.99999C17.5 11.3833 14.1667 12.5 10 12.5C5.83333 12.5 2.5 11.3833 2.5 9.99999" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default IcDatabase
